import { Component, Input, OnInit } from '@angular/core';
import { AgentService } from '../services/agent.service';
import { AgentExamHandlerComponent } from './agent-exam.handler';

@Component({
  selector: 'sym-agent-exam',
  templateUrl: './agent-exam.component.html',
  styleUrls: ['./agent-exam.component.scss'],
})
export class AgentExamComponent extends AgentExamHandlerComponent implements OnInit {
  constructor(agentService: AgentService) {
    super(agentService);
  }

  ngOnInit() {}
}
